"use client";

import { LenisRef, ReactLenis } from "lenis/react";
import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function LenisScrollProvider() {
    const lenisRef = useRef<LenisRef>(null);

    useEffect(() => {
        function update(time: any) {
            lenisRef.current?.lenis?.raf(time * 1000);
        }

        gsap.ticker.add(update);

        return () => gsap.ticker.remove(update);
    }, []);

    return (
        <ReactLenis
            ref={lenisRef}
            root
            options={{
                autoRaf: false,
                prevent: (node) =>
                    node.classList.contains("cookie-modal") ||
                    node.classList.contains("body-scroll-lock-container"),
            }}
        />
    );
}
